import { render, staticRenderFns } from "./Guias.vue?vue&type=template&id=6484921b&scoped=true"
import script from "./Guias.vue?vue&type=script&lang=js"
export * from "./Guias.vue?vue&type=script&lang=js"
import style0 from "./Guias.vue?vue&type=style&index=0&id=6484921b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484921b",
  null
  
)

export default component.exports